/** Fallback copy used by major test cards when the template has no description. */
export const MAJOR_TEST_DESCRIPTIONS: Record<number, string> = {
  1: 'Identifiez les 10 valeurs qui orientent vos choix et donnent du sens à ce que vous faites.',
  2: 'Identifiez vos huit besoins fondamentaux, au travail comme dans votre vie personnelle, pour des décisions qui vous ressemblent.',
  3: 'Cernez vos sept besoins professionnels fondamentaux pour un environnement épanouissant.',
  4: 'Explorez les 32 facettes de votre personnalité et révélez vos affinités naturelles.',
  5: 'Mesurez vos 16 soft skills clés et identifiez vos leviers de développement.',
  6: "Clarifiez vos pistes d'orientation et vos préférences d'études.",
  7: "La version pensée pour les adolescents : 32 profils pour mieux se connaître et éclairer ses premiers choix d'orientation.",
};

export const getMajorTestTemplateDescription = (
  testId: number,
  templateDescription?: string | null,
): string => templateDescription || MAJOR_TEST_DESCRIPTIONS[testId] || '';
